import * as React from 'react';
import { Link } from 'react-router-dom';
import { Groups } from '../../../Enum/Groups';
import { FilterInterface } from '../../../Filter/FilterInterface';
import { RangeFilterValue } from '../../../Filter/RangeFilterValue';
import { ProductInterface } from '../../../Model/Product';
import { FilterService } from '../../../Service/FilterService';
import { Trans } from '../../Trans';
import { AbstractFinder, FinderProps } from '../AbstractFinder';

interface LinearActuatorFinderProps extends FinderProps {
}

export class LinearActuatorFinder extends AbstractFinder<LinearActuatorFinderProps> {
    get group(): Groups {
        return Groups.LinearActuator;
    }

    protected renderHeadline(filteredProducts: ProductInterface[], allProducts: ProductInterface[]): JSX.Element {
        return <h1>
            <Link to="/">Home</Link> &gt; <Trans>Stellantriebe</Trans>
        </h1>;
    }

    protected renderFooter(
        rootProducts: ProductInterface[],
        filteredProducts: ProductInterface[],
        allProducts: ProductInterface[]
    ): JSX.Element | null {
        return <div className="pf-finder-footer">
            {/*<ul>*/}
            {/*    <li><strong>Max. Materialgeschwindigkeit (m/s)</strong></li>*/}
            {/*</ul>*/}
        </div>;
    }

    protected getInitialFilters(): FilterInterface<any>[] {
        return [
            FilterService.oneOf('Regelungsart', [], false),
            FilterService.range('Vorschubkraft', RangeFilterValue.empty(), false),
            FilterService.range('Verstellgeschwindigkeit', RangeFilterValue.empty(), false),
        ];
    }
}
